import React from "react";
import planPaused from "../../assets/img/subscription-paused.svg";
import { StyledButton } from "../../styledComponents/buttons";
import { CapitalizedH3 } from "../../styledComponents/common";
import { getCurrencySymbol, getPlanName, getPlanType, reformatDate } from "../../utils/helpers";
import CardContainer from "./CardContainer";

const PausedPlan = ({
  planInfo,
  manageSubscription,
  isBilling,
  actions,
  openBillingPortal,
  billingPortalSessionLoading,
}) => {
  const displayPlanId =
    planInfo?.payment_information?.price_id ||
    planInfo?.price_id ||
    planInfo?.paddle_plan_id;
  const subscriptionActions = actions || {};
  const scheduledResumeAt =
    planInfo?.scheduled_change?.action === "resume"
      ? planInfo?.scheduled_change?.effective_at
      : null;

  const handleManageSubscriptionClick = (event) => {
    event.preventDefault();

    openBillingPortal?.(planInfo);
  };

  return (
    <div className="subscontent">
      <div
        style={{ padding: "2.5rem 2.5rem 0rem 2.5rem" }}
        className="innerTop">
        <p className="subheader">Current Plan</p>
        {scheduledResumeAt && (
          <div
            style={{
              marginBottom: "20px",
              padding: "14px 16px",
              borderRadius: "12px",
              backgroundColor: "#eef4ff",
              color: "#1d4ed8",
              fontSize: "14px",
              lineHeight: "1.5",
            }}
          >
            Your subscription is scheduled to resume on{" "}
            {reformatDate(scheduledResumeAt)}.
          </div>
        )}
        <div className="subs-rate-parent">
          <div className="paused-subs-rate-container">
              <CapitalizedH3>
                {getPlanName(displayPlanId) === "Unknown"
                  ? planInfo?.plan_name || "Unknown"
                  : getPlanName(displayPlanId)}
              </CapitalizedH3>
              <span className="subs-rate">{getCurrencySymbol(planInfo?.currency) + planInfo?.unit_price + getPlanType(displayPlanId) }</span>
            </div>
          <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
            {subscriptionActions.can_resume !== false && (
              <StyledButton
                onClick={() => {
                  if (isBilling) {
                    openBillingPortal?.(planInfo);
                    return;
                  }

                  manageSubscription({ pause: false });
                }}
                disabled={subscriptionActions.can_resume === false}
                backgroundColor="#33CDD1"
                textColor="#fff"
                fontSize="16px"
                fontWeight="600"
                width="180px"
                hoverBackgroundColor="#3ab7bb">
                Activate Plan
              </StyledButton>
            )}
            {isBilling && (
              <button
                type="button"
                onClick={handleManageSubscriptionClick}
                disabled={billingPortalSessionLoading}
                style={{
                  width: "180px",
                  alignSelf: "center",
                  textAlign: "center",
                  color:
                    !billingPortalSessionLoading
                      ? "#007bff"
                      : "#98a2b3",
                  fontSize: "16px",
                  fontWeight: "600",
                  textDecoration: "none",
                  background: "transparent",
                  border: "none",
                  padding: 0,
                  cursor:
                    !billingPortalSessionLoading
                      ? "pointer"
                      : "not-allowed",
                }}>
                {billingPortalSessionLoading
                  ? "Opening portal..."
                  : "Manage Subscription"}
              </button>
            )}
          </div>
        </div>
        <div className="subcenter">
          <div className="paused-plan-content">
            <div
              style={{
                margin: "20px 0",
                fontSize: "16px",
              }}>
              <p
                style={{
                  color: "#52575f",
                }}>
                Status
              </p>
              <span>
                <img
                  style={{
                    height: "20px",
                    width: "20px",
                    marginRight: "10px",
                  }}
                  src={planPaused}
                  alt="plan paused"
                  width="100%"
                />
                Subscription Paused
              </span>
            </div>
            <div>
              <p style={{ color: "#52575f" }}>
                Member Since{" "}
                <span style={{ color: "#000" }}>
                  {reformatDate(planInfo?.created_at)}
                </span>{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
      <CardContainer
        cardInfo={planInfo?.payment_information}
        updateURL={planInfo?.management_url}
        isBilling={isBilling}
        actions={subscriptionActions}
      />
    </div>
  );
};

export default PausedPlan;
